import { Routes } from '@angular/router';
import { faUserSecret } from '@fortawesome/pro-duotone-svg-icons';
import { genericResolver } from '@nittenapps/api';
import { dirtyGuard } from '@nittenapps/common';
import { NavItem } from '@nittenapps/components';

export const INVESTIGATION_ITEMS: NavItem[] = [
  {
    label: 'Investigaciones',
    icon: faUserSecret,
    iconSet: 'duo',
    roles: ['investigation', 'investigation_mngr'], //Actualizar rol
    children: [
      {
        label: 'Investigaciones',
        icon: faUserSecret,
        iconSet: 'duo',
        roles: ['investigation', 'investigation_mngr'],
        routerLink: ['investigation', 'investigation'],
      },
    ],
  },
];

export const ROUTES: Routes = [
  {
    path: 'investigation',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Investigaciones',
      roles: ['investigation', 'investigation_mngr'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./investigation/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./investigation/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.claim?.extNumber || 'Nuevo'}` },
        },
      },
    ],
  },
];
